var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"btn btn-outline-info round btn-file"},[_c('b-icon',{staticStyle:{"vertical-align":"middle"},attrs:{"icon":"cloud-upload-fill","aria-hidden":"true","font-scale":"0.9"}}),_vm._v(" "+_vm._s(_vm.label)+" "),_c('input',{attrs:{"type":"file","multiple":_vm.multiple},on:{"change":$event => _vm.$emit('change', $event)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }